import React, { useState, useEffect } from "react";
import {
  Box,
  Stack,
  Typography,
  OutlinedInput,
  InputAdornment,
  IconButton,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import { CloudUpload, CopyAllOutlined, HighlightOff } from "@mui/icons-material";
import axios from "axios";
import { useRef } from "react";

// Utility to convert file to base64
const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

    const attachAllowTypes = [
    "image/jpg",
    "image/png",
    "image/PNG",
    "image/gif",
    "image/jpeg",
    "image/JPEG",
    "image/JPG",
    "image/webp",
    "application/pdf",
    "application/x-zip-compressed",
    "application/postscript",
    "text/plain",
    "audio/mpeg",
    "text/javascript",
    "text/csv",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "video/mp4",
  ];

export default function DynamicAttachmentView({
label = "Attachment",
  name = "attachment",
  itemPicName="serviceAttach",
 itemType="updateServiceAttach",
  errorMessage,
  attachments = [],
  onFileSelect,
  MAX_FILE_SIZE_MB = 10,
  MAX_FILES = 5,
  attachmentList = [],
  setAttachmentList,
  user = {},
  croom,
  singleMsgUser,
  onGcTag,
  setFileRefer,
  fileRefer,
  allowedTypes = attachAllowTypes,
}) {
  const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
  const hasSetFileRefer = useRef(false);
  const [isDragging, setIsDragging] = useState(false);

  const [previewFiles, setPreviewFiles] = useState([]);

  // Upload to server
//   const uploadAttachmentToServer = async (file, index) => {
//     const localPreviewUrl = URL.createObjectURL(file);
//     const fileTypeGroup = file.type.startsWith("image")
//       ? "image"
//       : file.type.startsWith("video")
//       ? "video"
//       : "file";

//     const tempItem = {
//       file_name: file.name,
//       fileType: file.type,
//       attach_url: localPreviewUrl,
//       isUploading: true,
//       progress: 70,
//     };
//     setAttachmentList((prev) => [...prev, tempItem]);

//     try {
//       const base64 = await getBase64(file);

//       const attachmentPayload = {
//         attach_file: base64,
//         attach_filename: file.name,
//         attachExten: file.type.split("/")?.[1] || "bin",
//         attachSize: file.size,
//         itemPicName: itemPicName ?? "portalAttach",
//                 picName: itemPicName ?? "portalAttach",
//                 itemName: itemPicName ?? "portalAttach",

//         prev_url: "",
//         attachmentRefer:  "",
//         fileType: fileTypeGroup,
//       };

//       const payload = {
//         request_type: "image",
//         poster: user?.sopnoid || "",
//         cRefer: croom || user?.portal || "",
//         request_array: {
//           item: fileTypeGroup,
//           itemType: itemType ?? "new",
//           item_refer: fileRefer ? fileRefer : "",
//           post_refer: fileRefer ? fileRefer : "",
//           community: "",
//           taskid: "portalAttach",
//           portal: croom || user?.portal || "",
//           room_id: croom || user?.portal || "",
//           devip: "11.1.1.1",
//           prev_url: "",
//         itemPicName: itemPicName ?? "portalAttach",
//         itemName: itemPicName ?? "portalAttach",
//         picName: itemPicName ?? "portalAttach",
//           attachment: [attachmentPayload],
//           at_reply_id: "",
//         },
//       };

//       const res = await axios.post(
//         "https://ghorami.com/custom_pay/attachment/crm_attachNewFile.php",
//         payload
//       );

//       const responseData = Array.isArray(res.data) ? res.data[0] : res.data;

//       if (responseData?.file_res?.url && responseData?.file_refer) {
//   const { url } = responseData.file_res;
//   const fileReferFromServer = responseData.file_refer;
//   const gc_tag = responseData.gc_tag;

//   // ✅ Update shared file refer if not already set
//   // if (!fileRefer && typeof setFileRefer === "function") {
//   //   setFileRefer(fileReferFromServer);
//   // }

// // Inside uploadAttachmentToServer
// if (!hasSetFileRefer.current && (fileRefer === null || fileRefer === "") && typeof setFileRefer === "function") {
//   setFileRefer(fileReferFromServer);
//   hasSetFileRefer.current = true;
// }

//   // ✅ Notify parent of new gc_tag
//   if (typeof onGcTag === "function") {
//     onGcTag(gc_tag);
//   }

//   setAttachmentList((prev) =>
//     prev.map((item, i) =>
//       i === index
//         ? {
//             ...responseData.file_res,
//             attach_url: url,
//             file_refer: fileReferFromServer,
//             gc_tag,
//             file_name: file.name,
//             fileType: file.type,
//             isUploading: false,
//             progress: 100,
//           }
//         : item
//     )
//   );
// }else {
//         throw new Error("Invalid server response");
//       }


//       URL.revokeObjectURL(localPreviewUrl);
//     } catch (err) {
//       console.error("Upload error", err);
//       setAttachmentList((prev) => prev.filter((_, i) => i !== index));
//     }
//   };

 const uploadAttachmentToServer = async (file) => {
    if (!file || !allowedTypes.includes(file.type)) {
      alert("Unsupported file type.");
      return;
    }

    const localPreviewUrl = URL.createObjectURL(file);
    const fileTypeGroup = file.type.startsWith("image")
      ? "image"
      : file.type.startsWith("video")
      ? "video"
      : "file";

    const tempIndex = attachmentList.length;
    const tempItem = {
      file_name: file.name,
      fileType: file.type,
      attach_url: localPreviewUrl,
      isUploading: true,
      progress: 70,
    };

    setAttachmentList((prev) => [...prev, tempItem]);

    try {
      const base64 = await getBase64(file);
      const currentFileRefer = fileRefer || "";

      const attachmentPayload = {
        attach_file: base64,
        attach_filename: file.name,
        attachExten: file.type.split("/")?.[1] || "bin",
        attachSize: file.size,
        itemPicName: itemPicName ?? "serviceAttach",
        prev_url: "",
        attachmentRefer: currentFileRefer ?? "",
        fileType: fileTypeGroup,
      };


      const payload = {
        request_type: "image",
          poster: user?.sopnoid,
        cRefer: user?.c_refer,
        request_array: {
          item: fileTypeGroup,
          requFrom: "marketPlace",
          itemType: "new",
          item_refer: currentFileRefer,
          post_refer: currentFileRefer,
          community: croom ?? currentFileRefer,
          taskid: croom ?? currentFileRefer ?? "",
          room_id: itemPicName ?? "servicePic",
          devip: "11.1.1.1",
          prev_url: "",
          itemName: itemPicName ?? "serviceAttach",
          attachment: [attachmentPayload],
          at_reply_id: "",
        },
      };

      const res = await axios.post(
        "https://aps.songjukti.com/profile/login/api/api_tracker_attachNew.php",
        payload
      );

      const responseData = Array.isArray(res.data) ? res.data[0] : res.data;

      if (responseData?.file_res?.url && responseData?.file_refer) {
        const { url } = responseData.file_res;
        const fileReferGet = responseData.file_refer;
        const gctag = responseData.gc_tag;

        // Set file refer only once
        if (!hasSetFileRefer.current && typeof setFileRefer === "function") {
          setFileRefer(fileReferGet);
          hasSetFileRefer.current = true;
        }

        if (typeof onGcTag === "function") {
          onGcTag(gctag);
        }

        setAttachmentList((prev) =>
          prev.map((item, i) =>
            i === tempIndex
              ? {
                  ...responseData.file_res,
                  attach_url: url,
                  file_refer: fileReferGet,
                  gc_tag: gctag,
                  file_name: file.name,
                  fileType: file.type,
                  isUploading: false,
                  progress: 100,
                }
              : item
          )
        );
      } else {
        throw new Error("Invalid server response structure");
      }

      URL.revokeObjectURL(localPreviewUrl);
    } catch (error) {
      console.error("Upload failed", error);
      setAttachmentList((prev) => prev.filter((_, i) => i !== tempIndex));
    }
  };
  // Process file selection
  const handleFileProcessing = (files) => {
    const validFiles = [];
    const oversizedFiles = [];

    files.forEach((file) => {
      if (file.size > MAX_FILE_SIZE_BYTES) {
        oversizedFiles.push(file.name);
      } else {
        validFiles.push(file);
      }
    });

    if (oversizedFiles.length > 0) {
      alert(
        `Files too large:\n${oversizedFiles.join(", ")} (Limit: ${MAX_FILE_SIZE_MB}MB)`
      );
    }

    if (attachments.length + validFiles.length > MAX_FILES) {
      alert(`Only ${MAX_FILES} attachments allowed.`);
      return;
    }

    validFiles.forEach((file, idx) => {
      uploadAttachmentToServer(file, attachmentList.length + idx);
    });
  };

  // File input
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    handleFileProcessing(files);
  };

  // Drag & drop
  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };
  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    handleFileProcessing(files);
  };

  // Delete from server
  const handleDeleteAttachment = async (fileRefer, index) => {
    if (!fileRefer) return;

    try {
      const response = await axios.get(
        `https://aps.songjukti.com/profile/login/api/api_tracker_attachNew.php?request_type=deleteImage&item_refer=${fileRefer}&poster=${user?.sopnoid}&item=${itemPicName}`
      );
      const result = response.data;

      if (result?.errTyp === "success") {
        setAttachmentList((prev) => prev.filter((_, i) => i !== index));
      } else {
        alert(result?.errMSG || "Server deletion failed.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      alert("Network error during delete.");
    }
  };

  // Sync with attachments (optional external prop)
useEffect(() => {
  const newPreviews = attachments.map((file, index) => ({
    file,
    previewUrl: file.attach_url || file.url,
    previewType: file.fileType?.split("/")?.[0] || "file",
    name: file.file_name || file.attach_filename || `file-${index}`,
    uniqueKey: `${file.file_name}-${index}`,
  }));

  // Check if previews actually changed before updating
  const isSame = JSON.stringify(previewFiles) === JSON.stringify(newPreviews);

  if (!isSame) {
    setPreviewFiles(newPreviews);
  }
}, [attachments]);


  // useEffect(() => {
  //   if (attachments.length > 0) {
  //     const newPreviews = attachments.map((file, index) => {
  //       return {
  //         file,
  //         previewUrl: file.attach_url || file.url,
  //         previewType: file.fileType?.split("/")?.[0] || "file",
  //         name: file.file_name || file.attach_filename || `file-${index}`,
  //         uniqueKey: `${file.file_name}-${index}`,
  //       };
  //     });
  //     setPreviewFiles(newPreviews);
  //   } else {
  //     setPreviewFiles([]);
  //   }
  // }, [attachments]);

  return (
    <Stack spacing={1}>
      {/* Label */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" sx={{ fontSize: 12, fontWeight: 500 }}>
          {label}
        </Typography>
        {errorMessage && (
          <small style={{ color: "#CB0101" }}>{errorMessage}</small>
        )}
      </Stack>

      {/* Dropzone & Upload Input */}
      <Box
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        sx={{
          border: "2px dashed #aaa",
          borderColor: isDragging ? "#760505" : "#ccc",
          borderRadius: 2,
          padding: 2,
          textAlign: "center",
          backgroundColor: isDragging ? "#fbe9e7" : "transparent",
          cursor: "pointer",
        }}
      >
        <Typography sx={{ fontSize: 12, mb: 1 }}>
          Drag and drop files here, or click to upload
        </Typography>
        <OutlinedInput
          type="file"
          name={name}
          size="small"
          accept="image/*,application/pdf,video/mp4"
          onChange={handleFileSelect}
          disabled={attachments.length >= MAX_FILES}
          sx={{
            width: "100%",
            borderRadius: "6px",
            fontSize: 12,
            fontWeight: 500,
            backgroundColor: "white",
          }}
          endAdornment={
            <InputAdornment position="end">
              <CloudUpload sx={{ color: "#760505", fontSize: 12 }} />
            </InputAdornment>
          }
          inputProps={{ multiple: true }}
        />
      </Box>

      {/* Previews */}
      {attachmentList.map((file, index) => {
  // const previewUrl = file.attach_url || file.url;
  const previewUrl = file.pic_url || file.attach_url || file.url;
  const fileType = file.ext || file.fileType || "file";
  const name = file.file_name || file.attach_filename || `file-${index}`;
  const isUploading = file.isUploading;
  const fileRefer = file?.gc_tag || file?.gctag || file?.refer;
  const fullUrl = previewUrl?.startsWith("http") ? previewUrl : `//yeapbe.com/${previewUrl}`;

const handleCopy = (text) => {
  if (!text) return;
  navigator.clipboard.writeText(text).then(() => {
    console.log("Copied to clipboard:", text);
    // You can optionally show a snackbar here
  });
};
  // const isUploading = file.isUploading;

  return (
    <Stack
      key={`${name}-${index}`}
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      px={2}
      py={1}
      sx={{
        backgroundColor: "lightcyan",
        borderRadius: 1,
        opacity: isUploading ? 0.5 : 1,
        position: "relative",
      }}
    >
        
      <Stack direction="row" alignItems="center" gap={2}>
        {( fileType.startsWith("image") ||
  fileType.endsWith("png") ||
  fileType.endsWith("jpg") ||
  fileType.endsWith("jpeg") ||
  fileType.endsWith("JPG") ||
  fileType.endsWith("JPEG")) && (
          <img
            src={previewUrl ? fullUrl : ""}
            alt={name}
            style={{ width: 40, height: 40, objectFit: "cover" }}
          />
        )}
        {(fileType.startsWith("video") || fileType.startsWith("mp4")) && (
          <video width="40" height="40" controls src={previewUrl} />
        )}
        {(fileType === "application/pdf" || fileType === "pdf")&& (
          <Typography variant="body2" sx={{ fontSize: "11pt" }}>
            PDF
          </Typography>
        )}
    <Box>
  {/* <Typography variant="body2" sx={{ fontSize: "11pt" }}>
    {name}
  </Typography> */}

  {previewUrl && (
    <Box display="flex" alignItems="center">
      <Typography sx={{ mr: 1, wordBreak: "break-all" }}> {name}</Typography>
      <Tooltip title="Copy to clipboard">
        <IconButton size="small" onClick={() => handleCopy(`https:${fullUrl}`)}>
          <CopyAllOutlined fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  )}
</Box>
       
      </Stack>

       
      {isUploading ? (
        <Box sx={{ position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)" }}>
          <CircularProgress size={24} color="primary" />
        </Box>
      ) : (
        <IconButton
          aria-label="delete"
          size="small"
          onClick={() => handleDeleteAttachment(fileRefer, index)}
        >
          <HighlightOff fontSize="inherit" />
        </IconButton>
      )}
    </Stack>
    
     
    
  );
})}

    </Stack>
  );
}
